//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiChevronRight,
  mdiCreditCardOutline,
} from '@mdi/js'

export default {
  name: 'ActionCard',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    cardNumber: {
      type: String,
      default: '',
    },
    cardDate: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      icons: {
        mdiChevronRight,
        mdiCreditCardOutline,
      },
    }
  },
}
